'use client'

import Link from "next/link";
import {useSelectedLayoutSegments} from "next/navigation";
import {Progress} from "@/components/ui/progress";
import {cn} from "@/lib/utils";

const stepsItems = [
    {id: 1, title: "Account Creation", description: "Create your account"},
    {id: 2, title: "Profile Setup", description: "Complete your profile"},
    {id: 3, title: "Questionary", description: "Know you better"},
    {id: 4, title: "Verification", description: "Verify your details"},
]

export function StepProgress() {


    const selectedLayoutSegments = useSelectedLayoutSegments('steps')
    const step = parseInt(selectedLayoutSegments[1]?.charAt(selectedLayoutSegments[1]?.length - 1) ?? "1")
    const progress = (step / stepsItems.length) * 100

    return <>
        <div className="flex justify-between  mb-1">
            {stepsItems.map(function (item) {
                const node = <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                        item.id < step
                            ? "bg-green-500 text-white"
                            : item.id === step
                                ? "bg-blue-500 text-white"
                                : "bg-gray-200 text-gray-600"
                    }`}
                >
                    {item.id < step ? "✓" : item.id}
                </div>
                return <div key={item.id}
                            className={cn("flex flex-col",( item.id === 2 || item.id === 3) && "items-center ", item.id === 4 && "items-end ")}>
                    {step > 1 && step !== item.id ? <Link onClick={() => {
                        const d = new Date();
                        d.setTime(d.getTime() + 3000);
                        const expires = "expires=" + d.toUTCString();
                        document.cookie = "step_1_edit" + "=" + d.getTime() + ";" + expires + ";path=/";
                    }}
                     href={`/account-request/step${item.id}`}>{node}</Link> : node}
                    <div className={cn("text-xs text-gray-500",)}>
                        {item.title}
                    </div>
                </div>;
            })}
        </div>

        <Progress value={progress} className="mb-2"/>

        <div className="text-center">
            <h1 className="text-lg font-semibold">{stepsItems[step - 1].title}</h1>
            <p className="text-sm text-muted-foreground">{stepsItems[step - 1].description}</p>
        </div>
    </>
}
